import { BodyText } from "@/components/ui";
import type { ChatMessage } from "@/features/Chat/types/chatMessageTypes";

interface InactivePatientMessageProps {
  message: ChatMessage;
}

export const InactivePatientMessage = ({
  message,
}: InactivePatientMessageProps) => {
  return (
    <div className="flex flex-col gap-2 justify-center items-center">
      <BodyText size="sm" textColor="primary" italic>
        {message.text}
      </BodyText>
    </div>
  );
};
